import React from 'react';

const TeamCard = ({ data }) => {
    const { img, name, tag } = data;
    return (
        <div className="col-lg-3 col-md-6">
            <div className="team_member">
                <div className="teambox">
                    <img src={img} alt="" />
                    <div className="teambox_inner">
                        <div className="team_social">
                            <ul>
                                <li className="instagram"><a><i className="ion-social-instagram-outline"></i></a></li>
                                <li className="twitter"><a><i className="ion-social-twitter"></i></a></li>
                                <li className="facebook"><a><i className="ion-social-facebook"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="teambox_intro">
                    <h5>{name}</h5>
                    <h6>{tag}</h6>
                    <p>Lorem ipsum dolor sit amet, consectetur a dipiscing elittempor incididunt ut labore et dolore magna aliqua. </p>
                </div>
            </div>
        </div>
    );
};

export default TeamCard;